import React ,{Component} from 'react';
import ReactModal from 'react-modal';
import {Link} from 'react-router-dom';
import styles from '../Mainpage/Mainpage.module.css';
import './searching.css';
import { getBinarySearchAnimations } from './Binary';


const ANIMATIONS_SPEED = 390;
const PRIMARY_COLOR  = 'white'
const SECONDARY_COLOR = 'brown'
const TERNARY_COLOR = 'black'
var Disable = false;


//Modal.setAppElement('#root');
class Searching extends Component{
    
    constructor() {
        super();
        this.state = {
          array: [],
          item:0,
          modal_state:false,
          found:false,
          pos:-1,
          complex:'',
          address:'/'
        };
      }
      componentDidMount(){
          const array = getinitialarray();
          this.setState({array});
      }
      handleChange = (evt) =>{
          if(Disable === false){
        const item = parseInt(evt.target.value);
        this.setState({
            item
        })
    }
      }
      resetArray(){
          if(Disable === false){
          const array = getinitialarray();
          this.setState({
              array,
              found:false,
              pos:-1,
              modal_state:false,
              complex:''
          });
         
          
      }
    }
      linear(){
          if(Disable === false){
              Disable = true;
              this.setState({address:'/search'});
        const resetButton = document.getElementById('reset');
        const binaryButton = document.getElementById('binary');
        resetButton.disabled = true;
        binaryButton.disabled = true;
        
          const {array,item} = this.state;
          const arrayBlocks = document.getElementsByClassName('block');
          const animations = []
          this.setState({complex:"O(n)"})

              for(let i =0;i<array.length;i++){

                  if(array[i]==item){

                      animations.push(i);
                      this.setState({
                          found:true,
                          pos:i
                      })
                      break;

                  }

                  animations.push(i);
                  animations.push(i);

              }
              var time = (animations.length-1)*ANIMATIONS_SPEED;
              setTimeout(()=>{
                Disable = false;
                this.setState({modal_state:true,address:'/'})
              },time);
                for(let i=0;i<animations.length;i++){

                    const currentBlock = arrayBlocks[animations[i]].style;
                    console.log(currentBlock.backgroundColor);
                    const currentText = arrayBlocks[animations[i]].firstChild.style;
                    const color = (i%2 === 0) ? SECONDARY_COLOR : PRIMARY_COLOR;
                    const text_color = (i%2 === 0) ? PRIMARY_COLOR : TERNARY_COLOR;
                    
                    setTimeout(() =>{

                        currentBlock.backgroundColor = color;
                        currentText.color = text_color;

                    },i*ANIMATIONS_SPEED)
                }
                
          }
      }
      binary(){
        if(Disable === false){
            Disable = true;
            this.setState({address:'/search'});
          let ANIMATIONS_SPEED = 500;
          let flip = 0;
          const COLOR_3 = 'yellow';
          let {array,item} = this.state;
            
          for(let i=0;i<array.length-1;i++){
              for(let j=0;j<array.length-i-1;j++){
                  if(array[j]>array[j+1]){
                      let temp = array[j];
                      array[j]=array[j+1];
                      array[j+1]=temp;
                  }
              }
          }
          this.setState({complex:"O(log n)"})
          for(let i=0;i<array.length;i++){
            if(array[i]==item){
                this.setState({
                    found:true,
                    pos:i
                })
            }
        }
          const arrayBlocks = document.getElementsByClassName('block');
          
        for(let i = 0;i<array.length;i++){
            
            arrayBlocks[i].style.backgroundColor = SECONDARY_COLOR;
            arrayBlocks[i].firstChild.style.color = PRIMARY_COLOR;
        
        }

        this.setState({array});
        const animations = getBinarySearchAnimations(array,item);
        var time = (animations.length-1)*ANIMATIONS_SPEED;
              setTimeout(()=>{
                Disable = false;
                this.setState({modal_state:true,address:'/'})
              },time);
          for(let i=0;i<animations.length;i++){
            
            if(animations[i][0]==1){
                
                const color = (flip == 0) ? COLOR_3 : SECONDARY_COLOR;
                const currentBlock = arrayBlocks[animations[i][1]].style;
                flip = flip^1;
                
                setTimeout(()=>{
                
                    currentBlock.backgroundColor = color;
                
                },i*ANIMATIONS_SPEED);
            }
            else if(animations[i][0]==2){

               const left = animations[i][1];
               const right = animations[i][2];
               
               setTimeout(()=>{
               
                for(let k=0;k<array.length;k++){
                if(k>=left && k<=right){
               
                    arrayBlocks[k].style.backgroundColor = SECONDARY_COLOR;
               
                }
                else{
               
                    arrayBlocks[k].style.backgroundColor = PRIMARY_COLOR;
                    arrayBlocks[k].firstChild.style.color = 'black';
               
                }
               } 
            },i*ANIMATIONS_SPEED);
            }
          }
        }
      }
      handleModal(){
        const arrayBlocks = document.getElementsByClassName('block');
          for(let i=0;i<this.state.array.length;i++){
            arrayBlocks[i].style.backgroundColor = PRIMARY_COLOR;
            arrayBlocks[i].firstChild.style.color = 'black';
          }
        this.setState({
            found:false,
            pos:-1,
            modal_state:false,
            complex:''

        })
      }
    render(){
        const {array} = this.state;
        return(
            <>
            <ReactModal 
                isOpen={this.state.modal_state}
                style={{
                    overlay: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(100, 100, 100, 0.75)'
                      },
                      content: {
                        position: 'absolute',
                        top: '170px',
                        left: '350px',
                        right: '350px',
                        bottom: '160px',
                        border: '1px solid #ccc',
                        background: '#fff',
                        overflow: 'hidden',
                        WebkitOverflowScrolling: 'touch',
                        borderRadius: '10px',
                        outline: '3px',
                        padding: '20px'
                      }
                }
                }
                >
                <h2 className="modal-data">Element {(this.state.found ? "Found" : "Not Found")}</h2>
                <h4 className="modal-data">Position: {this.state.pos == -1 ? '' : this.state.pos+1}</h4>
                <h5 className="modal-data">Time Complexity: {this.state.complex}</h5>
                <a className="modal-close" onClick={() =>{this.handleModal()}}>Close</a>
                </ReactModal>
                <div className="navbar-fixed">
                    <nav className="nav-wrapper white">
                        <div className="container">
                            <Link  to={this.state.address} className="brand-logo" className={styles.logo}><img src='/img/image.tj9vk9'  alt='logo' /></Link>
                                <ul className="right hide-on-med-and-down">
                                    <li>    
                                        <div class="center row">
                                            <div class="col s12 " >
                                                <div class="row" id="topbarsearch">
                                                    <div class="input-field col s6 s12 black-text">
                                                        <i class="black-text material-icons prefix">search</i>
                                                        <input type="text" placeholder="Element to search" id="autocomplete-input" onChange={this.handleChange} class="autocomplete black-text" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>          
                                    </li>
                                    <li><a className = "black-text" id = "reset"   onClick={() => this.resetArray()}>Reset</a></li>
                                    <li><a className = "black-text" id = "linear"  onClick={() => this.linear()}>Linear Search</a></li>
                                    <li><a className = "black-text" id = "binary"  onClick={() => this.binary()}>Binary Search</a></li>
                                </ul>
                        </div>
                    </nav>
                </div>       
                
                <div className="array-row">
                     {
                         array.map((value,blockidx)=>{
                             return(
                                 <div className="block" key = {blockidx}>
                                     <h6 className="data-num">{value}</h6>
                                 </div>
                             )
                         })
                     }
                </div>
                
                
            </>
        )
    }
}

const getinitialarray = () => {
    const array = [];
    for(let i=0;i<18;i++){
        array[i] = Math.floor(Math.random() * (99) + 1);
    }
    return array;
}

export default Searching